import ReportHeaderSkeleton from './skeletons/ReportHeaderSkeleton';
import ReportQaSkeleton from './skeletons/ReportQaSkeleton';

/**
 * Presentational report-page chrome skeleton (header + Q&A cards).
 * No ReportProvider required — safe as a Suspense fallback and for
 * /report-view-link while the redirect path is resolved.
 */
const ReportPageSkeleton = () => {
  return (
    <div className="placeholder-glow">
      <div id="topContent" className="container-fluid">
        <div className="ao_mainContainer">
          <ReportHeaderSkeleton />
        </div>
      </div>
      <div id="opinionQuestionResponse" className="container-fluid mt-3">
        <div className="ao_mainContainer">
          <ReportQaSkeleton />
        </div>
      </div>
    </div>
  );
};

export default ReportPageSkeleton;
